<app-header [forceLightBackground]="true"></app-header>
<div class="admin-dashboard">
  <div class="admin-dashboard--layout">
    <app-admin-sidebar class="admin-dashboard--sidebar"></app-admin-sidebar>
    <div class="admin-dashboard--content">
      <div class="page-container">
        <app-dataset-provider-dashboard></app-dataset-provider-dashboard>
      </div>
    </div>
  </div>
</div>
